import { AuthGuard } from '../../shared/guards/authGuard/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FuncionarioComponent } from './funcionario.component';
import { RegistroActivosFijosComponent } from './registro-activos-fijos.component';

const routes: Routes = [
  { path: '', component: FuncionarioComponent },
  { path: 'registro', component: RegistroActivosFijosComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FuncionarioRoutingModule { }
